<template>
  <div
    class="earning-container d-flex align-items-start justify-content-center mx-auto"
  >
    <img class="earning-icon" draggable="false" :src="getIcon" />

    <div v-if="iconText" class="icon-text text-center">
      {{ iconText }}
    </div>

    <div
      class="earning-btn to-center-abs gold-display text-center"
      :class="size"
    >
      <span
        class="earning-amount"
        :class="[
          size,
          lockedInfo && lockedInfo === 'unlocked' ? 'green' : 'text-white bold',
        ]"
      >
        <slot name="earning-amount-or-text"> </slot>
      </span>
      <img
        v-if="lockedInfo && lockedInfo === 'unlocked'"
        src="@/assets/img/cards/icon-set-complete.png"
      />
      <img
        v-else-if="lockedInfo && lockedInfo === 'locked'"
        src="@/assets/img/common/lock-close.png"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "EarningShield",
  props: {
    earning: {
      type: String,
      default: "gold",
    },
    size: {
      type: String,
      default: "",
    },
    lockedInfo: {
      type: String,
      default: "",
    },
    iconText: {
      type: String,
      default: "",
    },
  },
  computed: {
    getIcon: function () {
      switch (this.earning) {
        case "gold":
          return this.$whitelabel.currencies.primary.single;
        case "elixir":
          return this.$whitelabel.currencies.tertiary.single;
        case "card":
          return this.$whitelabel.assets.features.cards.icon;
        case "crown":
          return this.$whitelabel.currencies.secondary.single;
        case "loyalty":
          return this.$whitelabel.assets.features.loyalty.icon;
        case "xpboost":
          return this.$whitelabel.assets.features.booster.icon;
        case "user-league":
          return this.$whitelabel.assets.features.league.icon;

        default:
          return this.$whitelabel.currencies.primary.single;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.earning-container {
  position: relative;
  height: 100%;
  width: 100%;
  min-height: 128px;
  margin: 0 8px 0 8px;
  background: url(~@/assets/img/common/earning-shield-bg.png) center/100% 100%
    no-repeat;

  .earning-icon {
    max-width: 60%;
  }

  .icon-text {
    font-family: Ubuntu-Bold;
    font-size: 28.3px;
    color: white;
    padding-top: 20px;
  }

  .earning-btn {
    bottom: 20%;
    font-size: 16px;
    padding-top: 2px;
    &.gold-display {
      background-color: black;
      height: 32px;
      border-radius: 8px;
      border: 2px solid $text-accent;
      box-shadow: 0 0 16px $text-shadow--cyan, 0 0 8px $text-shadow--cyan,
        0 0 8px $text-shadow--cyan, 0 0 4px rgba(0, 94, 110, 0.8),
        0 0 4px rgba(0, 94, 110, 0.8);
    }
    .earning-amount {
      text-shadow: 0 0 16px $text-shadow--cyan, 0 0 8px $text-shadow--cyan;
    }

    &.lg {
      height: 35px;
    }
    img {
      max-width: 35px;
      position: absolute;
      right: -15px;
      top: -5px;
    }
  }

  .earning-amount.lg {
    font-size: 21px;
  }
  .green {
    color: $text-highlight-green;
    font-family: Ubuntu-Bold;
  }
}
</style>
